/**
 * Generated from PlanterPlantingIntroLayout.fla
 */
export function PlanterPlantingIntroLayout(this: IPlanterPlantingIntroLayout) {
	const bg = this.bg;
	PlanterPlantingIntroLayout_bg.call(this.bg);
	bg.x = 163.7;
	bg.y = -85.75;
	bg.width = 2479.34;
	bg.height = 1144.31;
	if (bg.onLayout) bg.onLayout();
	const homeButton = this.homeButton;
	PlanterPlantingIntroLayout_homeButton.call(this.homeButton);
	homeButton.x = 108;
	homeButton.y = 164.5;
	homeButton.width = 146.00;
	homeButton.height = 151.00;
	if (homeButton.onLayout) homeButton.onLayout();
	const grover = this.grover;
	PlanterPlantingIntroLayout_grover.call(this.grover);
	grover.x = 726.75;
	grover.y = 681.6;
	grover.width = 295.40;
	grover.height = 596.40;
	if (grover.onLayout) grover.onLayout();
	const abby = this.abby;
	PlanterPlantingIntroLayout_abby.call(this.abby);
	abby.x = 375.85;
	abby.y = 653.8;
	abby.width = 308.97;
	abby.height = 382.05;
	if (abby.onLayout) abby.onLayout();
	const skipButton = this.skipButton;
	PlanterPlantingIntroLayout_skipButton.call(this.skipButton);
	skipButton.x = 946.25;
	skipButton.y = 687.75;
	skipButton.width = 156.50;
	skipButton.height = 161.50;
	if (skipButton.onLayout) skipButton.onLayout();
	return this;
}
function PlanterPlantingIntroLayout_bg(this: IPlanterPlantingIntroLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("PlanterParty-Background.png", 0.198, 0.254);
	return this;
}
function PlanterPlantingIntroLayout_homeButton(this: IPlanterPlantingIntroLayout_homeButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("home-btn.png", 0.500, 0.500);
	return this;
}
function PlanterPlantingIntroLayout_grover(this: IPlanterPlantingIntroLayout_grover) {
	if (this.setLayoutTexture) this.setLayoutTexture("Grover-wave.png", 0.607, 0.995);
	return this;
}
function PlanterPlantingIntroLayout_abby(this: IPlanterPlantingIntroLayout_abby) {
	if (this.setLayoutTexture) this.setLayoutTexture("abby.png", 0.562, 0.916);
	return this;
}
function PlanterPlantingIntroLayout_skipButton(this: IPlanterPlantingIntroLayout_skipButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("skip-btn.png", 0.500, 0.500);
	return this;
}
interface IPlanterPlantingIntroLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IPlanterPlantingIntroLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IPlanterPlantingIntroLayoutSprite extends IPlanterPlantingIntroLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IPlanterPlantingIntroLayoutText extends IPlanterPlantingIntroLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IPlanterPlantingIntroLayoutPolygon extends Array<number> {
}
interface IPlanterPlantingIntroLayout {
	readonly bg: IPlanterPlantingIntroLayout_bg;
	readonly homeButton: IPlanterPlantingIntroLayout_homeButton;
	readonly grover: IPlanterPlantingIntroLayout_grover;
	readonly abby: IPlanterPlantingIntroLayout_abby;
	readonly skipButton: IPlanterPlantingIntroLayout_skipButton;
}
interface IPlanterPlantingIntroLayout_bg extends IPlanterPlantingIntroLayoutSprite {
}
interface IPlanterPlantingIntroLayout_homeButton extends IPlanterPlantingIntroLayoutSprite {
}
interface IPlanterPlantingIntroLayout_grover extends IPlanterPlantingIntroLayoutSprite {
}
interface IPlanterPlantingIntroLayout_abby extends IPlanterPlantingIntroLayoutSprite {
}
interface IPlanterPlantingIntroLayout_skipButton extends IPlanterPlantingIntroLayoutSprite {
}
